<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="chap1">ADMONITION</p>
<p class="chap_line"></p>
<p class="center"><span class="big">I</span>t is a fact of life that sin will haunt you if you are here in the mortal condition</p>
<p class="center">Which is exactly why the prophets, both new and old, have warned us of the consequences of sin’s one-way ride to perdition with clear words of admonition.</p>
<p class="center1">The still voice that can speak to those that choose to hear and obey those sweet precious words of counsel and redemption’s harking</p>
<p class="center">Is thunder rolling through their souls so strong that they can see the light of Christ’s love shine around them that it banishes Satan’s harpies.</p>
<p class="center1">to God the Father is for us the perfect conduit for holy edification</p>
<p class="center">As we learn to be more Christ-like in every facet of our lives, we understand the need for endless erudition.</p>
<p class="center1">It is a fact of life that sin will haunt you if you are here in the mortal condition</p>
<p class="center">Which is exactly why the prophets, both new and old, have warned us of the consequences of sin’s one-way ride to perdition with clear words of admonition.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap005.vue?63e7a915